
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Checkbox extends Vue {
  @Prop(String) readonly field!: Object;
  @Prop(String) readonly label!: string;
  @Prop(Function) readonly change!: Function;
}
